import "core-js/modules/es.object.to-string.js";
var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "activity-container"
  }, [_c("van-pull-refresh", {
    attrs: {
      "loading-text": _vm.$t("LoadingTxt"),
      "loosing-text": _vm.$t("LoosingTxt"),
      "pulling-text": _vm.$t("pullingTxt")
    },
    on: {
      refresh: _vm.onRefresh
    },
    model: {
      value: _vm.isLoading,
      callback: function callback($$v) {
        _vm.isLoading = $$v;
      },
      expression: "isLoading"
    }
  }, [_vm.activityData.length > 0 ? _c("van-list", {
    attrs: {
      finished: _vm.finished
    },
    on: {
      load: _vm.onLoad
    },
    model: {
      value: _vm.loading,
      callback: function callback($$v) {
        _vm.loading = $$v;
      },
      expression: "loading"
    }
  }, _vm._l(_vm.activityData, function (item, index) {
    return _c("van-cell", {
      key: index,
      staticClass: "item"
    }, [_c("div", {
      staticClass: "img-con",
      on: {
        click: function click($event) {
          return _vm.toDetail("activity", item.threadId, item.likeReward.postCount);
        }
      }
    }, [Object.prototype.toString.call(item["content"]["indexes"]) == "[object Object]" && item["content"]["indexes"]["101"]["body"].length > 0 ? _c("van-image", {
      attrs: {
        fit: "cover",
        src: item["content"]["indexes"]["101"]["body"][0].thumbUrl
      }
    }) : _vm._e(), _c("div", {
      staticClass: "title-con"
    }, [_c("div", {
      staticClass: "shadow"
    }, [_c("div", {
      staticStyle: {
        position: "absolute",
        bottom: "14px",
        left: "20px"
      }
    }, [new Date() > Date.parse(item.end_time2) ? _c("span", {
      staticClass: "word6"
    }, [_vm._v(_vm._s(_vm.$t("Ended")))]) : new Date() < Date.parse(item.disTime) ? _c("span", {
      staticClass: "join"
    }, [_vm._v(_vm._s(_vm.$t("ToBeStarted")))]) : _c("span", {
      staticClass: "join"
    }, [_vm._v(_vm._s(_vm.$t("signUp")))]), _c("div", {
      staticStyle: {
        "word-break": "break-all",
        display: "-webkit-box",
        "-webkit-box-orient": "vertical",
        "-webkit-line-clamp": "2",
        overflow: "hidden"
      },
      domProps: {
        textContent: _vm._s(item.title)
      }
    })])])])], 1), item.position.address ? _c("div", {
      staticClass: "position"
    }, [_c("img", {
      attrs: {
        src: require("../../../assets/images/ic_mg_activity_address.png"),
        alt: ""
      }
    }), _c("span", [_vm._v(_vm._s(item.position.address))])]) : _vm._e(), item.start_at1 || item.end_at1 ? _c("div", {
      staticClass: "time"
    }, [_c("img", {
      attrs: {
        src: require("../../../assets/images/ic_mg_activity_time.png"),
        alt: ""
      }
    }), _c("span", [_vm._v(_vm._s(item.start_at1) + " - " + _vm._s(item.end_at1))]), new Date() > Date.parse(item.end_time2) && !item.activity_registration ? _c("div", {
      staticClass: "word8"
    }, [_vm._v(_vm._s(_vm.$t("join")) + " ")]) : new Date() > Date.parse(item.end_time2) && item.activity_registration ? _c("div", {
      staticClass: "word8"
    }, [_vm._v(_vm._s(_vm.$t("joined")) + " ")]) : [!item.activity_registration ? _c("div", {
      class: ["word7", {
        disabled: new Date() < Date.parse(item.disTime)
      }],
      on: {
        click: function click($event) {
          $event.stopPropagation();
          return _vm.toJoin(1, item.threadId, item);
        }
      }
    }, [_vm._v(_vm._s(_vm.$t("join")) + " ")]) : _c("div", {
      staticClass: "word7",
      on: {
        click: function click($event) {
          $event.stopPropagation();
          return _vm.toJoin(0, item.threadId, item);
        }
      }
    }, [_vm._v(_vm._s(_vm.$t("joined")) + " ")])]], 2) : _vm._e()]);
  }), 1) : _vm._e()], 1), _vm.showNoData ? _c("div", [_c("div", {
    staticClass: "no-data"
  }, [_vm._v(" " + _vm._s(_vm.$t("NoData")) + " ")])]) : _vm._e()], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };